import { beneficiaryRoutes } from '@/router/routes/beneficiaries'
import { cryptoRoutes } from '@/router/routes/crypto'
import { homeRoutes } from '@/router/routes/home'
import { reportRoutes } from '@/router/routes/reports'
import { settingsRoutes } from '@/router/routes/settings'
import { userRoutes } from '@/router/routes/users'
import { walletRoutes } from '@/router/routes/wallets'

export const appRoutes = [
  {
    path: '/',
    component: () => import('@/layouts/default/Index.vue'),
    children: [
      {
        path: '',
        name: 'Main',
        redirect: {
          name: 'Home',
        },
      },
      ...homeRoutes,
      ...walletRoutes,
      ...settingsRoutes,
      ...beneficiaryRoutes,
      {
        path: 'ui',
        name: 'Ui',
        component: () => import('@/layouts/ui/Index.vue'),
      },
      {
        path: 'deprecations',
        name: 'Deprecations',
        component: () => import('@/components/deprecations/Index.vue'),
      },
      ...userRoutes,
      ...reportRoutes,
      ...cryptoRoutes,
      {
        path: 'donate',
        name: 'Donate',
        component: () => import('@/components/donate/Index.vue'),
      },
    ],
    meta: {
      requireAuth: true,
      requireBootstrap: true,
    },
  },
]
